import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { HilOpportunityType } from 'app/pages/HumanInTheLoopPage/types';

export type HilOpportunityTypeToggleProps = {
  value: HilOpportunityType;
  onChange: (value: HilOpportunityType) => void;
  disabled?: boolean;
};

/**
 * TEST / LIVE switch for HIL segments needing attention.
 * Maps UI "LIVE" → API `opportunity_type=active`.
 */
export default function HilOpportunityTypeToggle({
  value,
  onChange,
  disabled = false,
}: HilOpportunityTypeToggleProps) {
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size="small"
      disabled={disabled}
      onChange={(_, next: HilOpportunityType | null) => {
        if (next == null) return;
        onChange(next);
      }}
      aria-label="HIL automation mode"
      sx={{
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '16px',
        overflow: 'hidden',
        '& .MuiToggleButton-root': {
          border: 'none',
          px: 1.5,
          py: 0.5,
          fontSize: '0.75rem',
          fontWeight: 600,
          minWidth: 65,
          height: 28,
          textTransform: 'none',
          color: 'text.secondary',
          '&.Mui-selected': {
            backgroundColor: 'primary.main',
            color: 'primary.contrastText',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          },
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        },
      }}
    >
      <ToggleButton value="test" aria-label="TEST automations">
        TEST
      </ToggleButton>
      <ToggleButton value="active" aria-label="LIVE automations">
        LIVE
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
